import React, { useState, useEffect } from 'react';
import './PrivacyPolicy.css';
import { motion } from 'framer-motion';
import { FaShieldAlt, FaLock, FaUserSecret, FaRegFileAlt, FaBalanceScale } from 'react-icons/fa';
// No react-router-dom imports needed here if not used
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { safeFetch } from '../utils/apiUtils';

const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.6, ease: "easeOut" }
    }
};

const getIcon = (type) => {
    switch (type) {
        case 'shield': return <FaShieldAlt />;
        case 'lock': return <FaLock />;
        case 'file': return <FaRegFileAlt />;
        case 'balance': return <FaBalanceScale />;
        case 'user': return <FaUserSecret />;
        default: return <FaShieldAlt />;
    }
};

const PrivacyPolicy = () => {
    const [privacy, setPrivacy] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchPrivacy = async () => {
            try {
                const { ok, data: result } = await safeFetch('https://aayushrealproperties.in/nimaibackend/public/api/privacy-policies');
                let privacyToSet = null;

                if (Array.isArray(result)) {
                    privacyToSet = result[0];
                } else if (result.data) {
                    privacyToSet = Array.isArray(result.data) ? result.data[0] : result.data;
                }

                if (ok && privacyToSet) {
                    setPrivacy(privacyToSet);
                }
            } catch (error) {
                console.error('Error fetching privacy policy:', error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchPrivacy();
    }, []);

    if (isLoading) {
        return (
            <div className="privacy-loading">
                <div className="loader"></div>
            </div>
        );
    }

    // Default data if none exists in API
    const displayData = privacy || {
        hero_title_part1: 'Your',
        hero_highlight_word: 'Privacy',
        hero_title_suffix: 'is Our Priority',
        hero_description: 'At Nimai Solutions, we believe in radical transparency and ethical data handling. This policy outlines how we protect your information.',
        last_updated_date: 'February 6, 2026',
        sections: []
    };

    return (
        <div className="privacy-container">
            <Navbar />

            <section className="privacy-hero">
                <div className="privacy-hero-bg-shape"></div>
                <motion.div
                    className="privacy-hero-content"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                >
                    <h1>{displayData.hero_title_part1} <span>{displayData.hero_highlight_word}</span> {displayData.hero_title_suffix}</h1>
                    <p>{displayData.hero_description}</p>
                </motion.div>
            </section>

            <div className="privacy-content-wrapper">
                <motion.div
                    className="privacy-card"
                    variants={fadeInUp}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                >
                    {displayData.sections.map((section, index) => (
                        <div key={index} className="privacy-section">
                            <h2>{getIcon(section.icon_type)} {index + 1}. {section.section_title}</h2>
                            <p>{section.content}</p>
                            {section.key_points && section.key_points.length > 0 && (
                                <ul className="privacy-list">
                                    {section.key_points.map((point, i) => (
                                        <li key={i}>{point}</li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    ))}

                    <div className="last-updated">
                        <span>Last Updated: {displayData.last_updated_date}</span>
                        <span onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} style={{ cursor: 'pointer', color: 'var(--accent-orange)', fontWeight: '600' }}>Back to top ↑</span>
                    </div>
                </motion.div>
            </div>

            <Footer />
        </div>
    );
};

export default PrivacyPolicy;
